export interface iconSet {
  rocket_mail:string,
  triangle_error:string
}

export const messageBoxIcon:iconSet = {
  rocket_mail: 'fas fa-paper-plane',
  triangle_error: 'fal fa-exclamation-triangle'
}
